import React from 'react';
import { FiLogIn, FiUsers, FiTrendingUp } from 'react-icons/fi';
import styles from './SummaryCards.module.css';

const SummaryCards = ({ summary, isSuperAdmin }) => {
  const cards = [
    { label: 'Logins Today', value: summary.loginsToday ?? 0, icon: <FiLogIn /> },
    { label: 'Logins This Week', value: summary.loginsThisWeek ?? 0, icon: <FiLogIn /> },
    { label: 'Logins This Month', value: summary.loginsThisMonth ?? 0, icon: <FiLogIn /> },
    { label: 'Active Users (month)', value: summary.uniqueActiveUsersThisMonth ?? 0, icon: <FiUsers /> },
  ];

  if (isSuperAdmin && summary.topDerasars?.[0]) {
    cards.push({
      label: 'Most Active Derasar',
      value: summary.topDerasars[0].name,
      icon: <FiTrendingUp />,
    });
  }

  return (
    <div className={styles.grid}>
      {cards.map((card) => (
        <div key={card.label} className={styles.card}>
          <div className={styles.icon}>{card.icon}</div>
          <div className={styles.value}>{card.value}</div>
          <div className={styles.label}>{card.label}</div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;
